import { Component, Prop, Watch, h } from '@stencil/core';

import { onQuestionAnswered } from '../../../actions/actions.answers';

@Component({
  tag: 'question-integer-range',
  styleUrl: 'question-integer-range.css',
})
export class QuestionIntegerRange {
  @Prop() heading: string = '';
  @Prop() questionId: string = '';
  @Prop() subHeading: string = '';
  @Prop({ mutable: true }) value: string = '';
  @Prop() rangeMin: number = 0;
  @Prop() rangeMax: number = 0;
  @Prop() order: 'descending' | 'ascending' = 'ascending';
  @Prop() inputDefaultLabel: string = '';
  @Prop() inputDefaultValue: string = null;

  onMinChange(evt) {
    const [_, max] = this.value.split(',');
    this.value = `${evt.detail},${max}`;
  }

  onMaxChange(evt) {
    const [min] = this.value.split(',');
    this.value = `${min},${evt.detail}`;
  }

  @Watch('value')
  onValueChange(newValue: string) {
    onQuestionAnswered(this.questionId, newValue);
  }

  buildOptions(min, max) {
    const years = Array.from(Array(max - min + 1).keys()).map((x) => x + min);

    if (this.order === 'descending') {
      years.reverse();
    }

    return years.map((y) => ({
      label: `${y}`,
      value: `${y}`,
    }));
  }

  buildMinOptions() {
    const [_, maxPart] = this.value.split(',');

    if (maxPart) {
      const maxValue = Math.max(this.rangeMin, parseInt(maxPart) || this.rangeMax);
      const min = this.rangeMin;
      const max = Math.min(this.rangeMax, maxValue);
      return this.buildOptions(min, max);
    }
    return this.buildOptions(this.rangeMin, this.rangeMax);
  }

  buildMaxOptions() {
    const [minPart] = this.value.split(',');

    if (minPart) {
      const minValue = Math.min(this.rangeMax, parseInt(minPart) || this.rangeMin);
      const min = Math.max(this.rangeMin, minValue);
      const max = this.rangeMax;
      return this.buildOptions(min, max);
    }
    return this.buildOptions(this.rangeMin, this.rangeMax);
  }

  render() {
    const [minPart, maxPart] = this.value.split(',');

    return (
      <div class="flex flex-row gap-2">
        <input-select
          inputDefaultLabel={this.inputDefaultLabel}
          inputDefaultValue={this.inputDefaultValue}
          class="flex-[1]"
          label={this.heading}
          options={this.buildMinOptions()}
          value={minPart}
          onValueChange={(e) => this.onMinChange(e)}
        />
        <input-select
          inputDefaultLabel={this.inputDefaultLabel}
          inputDefaultValue={this.inputDefaultValue}
          class="flex-[1]"
          label={this.heading}
          options={this.buildMaxOptions()}
          value={maxPart}
          onValueChange={(e) => this.onMaxChange(e)}
        />
      </div>
    );
  }
}
